module.exports = "<div class=\"tooltip\">\n  Hover over me\n  <span class=\"tooltiptext\">Tooltip text</span>\n</div>\n"